<div id="main">
  <app-alert></app-alert>
  <app-side-navigation></app-side-navigation>
  <app-top-navigation></app-top-navigation>
  <router-outlet></router-outlet>
</div>

@if (userInactiveState) {
  <div class="user_inactivity">
    <div class="inactive_div">
      <div class="inactive_title">Hello {{user}}!</div>
      <div class="inactive_subtitle">Do you want to stay logged in?</div>
      <div class="inactive_action">
        <button class="yes" (click)="stayLoggedin()">Yes</button>
        <button class="no" (click)="logout()">No</button>
      </div>
    </div>
  </div>
}



<div
  class="modal animated zoomIn"
  id="sessionExpired"
  tabindex="-1"
  role="dialog"
  aria-labelledby="sessionExpiredLabel"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
  >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5 class="modal-title" id="sessionExpiredLabel">
          Session Expired
        </h5>

        <p class="modal-sub-title">
          Enter your password  to continue
        </p>
        <form [formGroup]="sessionExpiredForm">
          <div class="form-row">
            <div class="form-group col-md-12">
              <div class="form-group">
                <span class="has-float-label">
                  <input
                    class="form-control"
                    id="password"
                    type="password"
                    placeholder=" "
                    formControlName="password"
                    />
                  <label for="password">Password</label>
                </span>
                @if (
                  sessionExpiredForm.get('password').errors &&
                  (sessionExpiredForm.get('password').dirty ||
                  sessionExpiredForm.get('password').touched)
                  ) {
                  <div
                    class="validation-message"
                    >
                    <span
                      class="validation-message"
                    [hidden]="
                      !sessionExpiredForm.get('password').hasError('required')
                    "
                      >
                      {{ validationMessage.password.required }}
                      <br />
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>


          <div class="form_actions">
            <div
              class="cancel_button"
              data-dismiss="modal"
              (click)="logout()"
              >
              Logout
            </div>
            @if (!isExpireLoading) {
              <button
                class="btn action_button"
                (click)="signBackIn(sessionExpiredForm.value)"
                >
                <i class="fa fa-plus animated slideIn"></i>
                Log Back In
              </button>
            }

            @if (isExpireLoading) {
              <div
                class="spinner-border spinner-border-sm ml-3"
                role="status"
                >
                <span class="sr-only">Loading...</span>
              </div>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
</div>